export const SEARCH_ERRORS = {
  QUOTA: 'GUEST_QUOTA_EXCEEDED',
  RATE_LIMIT: 'RATE_LIMIT_EXCEEDED',
  UNAVAILABLE: 'SEARCH_TEMPORARILY_UNAVAILABLE',
  UNAUTHORIZED: 'UNAUTHORIZED',
  TIMEOUT: 'TIMEOUT',
  NETWORK: 'NETWORK_ERROR',
  UNKNOWN: 'UNKNOWN',
};

export function classifySearchError(error) {
  const status = error?.response?.status;
  const code = error?.response?.data?.error;
  if (code === SEARCH_ERRORS.QUOTA) return SEARCH_ERRORS.QUOTA;
  if (code === SEARCH_ERRORS.RATE_LIMIT || (status === 429 && code !== SEARCH_ERRORS.QUOTA)) {
    return SEARCH_ERRORS.RATE_LIMIT;
  }
  if (status === 503 || code === SEARCH_ERRORS.UNAVAILABLE) return SEARCH_ERRORS.UNAVAILABLE;
  if (status === 401 || status === 403) return SEARCH_ERRORS.UNAUTHORIZED;
  if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout') || error?.message?.includes('TIMEOUT')) {
    return SEARCH_ERRORS.TIMEOUT;
  }
  if (error?.code === 'ERR_NETWORK' || error?.message?.includes('Network')) {
    return SEARCH_ERRORS.NETWORK;
  }
  return SEARCH_ERRORS.UNKNOWN;
}

export function retryAfterSeconds(error) {
  const body = error?.response?.data?.retryAfter;
  if (Number.isFinite(Number(body))) return Number(body);
  const header = error?.response?.headers?.['retry-after'] || error?.response?.headers?.['Retry-After'];
  const n = Number(header);
  return Number.isFinite(n) ? n : null;
}
